<script setup lang="ts">

import {faSpinnerThird} from "@fortawesome/pro-solid-svg-icons";
import {VStack} from "@/shared/components/ui/helper";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import type {HTMLAttributes} from "vue";
import {cn} from "@/shared/lib/utils.ts";
import {useI18n} from "vue-i18n";

interface Props {
  size?: '2xs' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '1x' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x'
  class?: HTMLAttributes['class']
}

const {t} = useI18n()
const props = withDefaults(defineProps<Props>(), {
  size: "2xl",
})

</script>

<template>
  <VStack :class="cn('h-96 text-slate-500 col-span-full', props.class)" justify="center" align="center">
    <FontAwesomeIcon :icon="faSpinnerThird" spin :size="size" class="text-slate-500"/>
    <slot v-if="$slots.default"/>
    <span v-else>{{t('shared.common.loading')}}</span>
  </VStack>
</template>

<style scoped>

</style>